<ion-header>
  <ion-toolbar color="medium">
    <ion-title style="color: white;">Record Sound for STT</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal('close')">
        <ion-icon name="close" color="light" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="recording-container" style="border: rgb(188, 183, 183) 2px solid;">

  <ion-grid class="content-grid">
    <ion-row class="title-row">
      <h1 class="text-title">{{ text_info.text }}</h1>
    </ion-row>

    <ion-row class="button-row">
      <ion-button class="action-button"
        [ngClass]="{'pulse': isRecording, 'red-button': isRecording}" 
        [disabled]="endClick || startClick" 
        (click)="startRecording()">
        {{ isRecording ? '🎤 Recording' : '▶ Start' }}
      </ion-button>

      <div [hidden]="pauseClick">
        <ion-button class="action-button" [disabled]="endClick || !startClick" (click)="pauseRecording()">⏸ Pause</ion-button>
      </div>
      
      <div [hidden]="!pauseClick">
        <ion-button class="action-button danger" (click)="continueRecording()" [disabled]="isPlaying">⏯ Continue</ion-button>
      </div>

      <ion-button class="action-button danger" [disabled]="endClick || !startClick" (click)="stopRecording()">⏹ Stop</ion-button>
    </ion-row>

    <ion-row class="button-row">
      <!-- <ion-button class="action-button save-button" *ngIf="endClick" (click)="saveRecording()">💾 Inference</ion-button> -->
      <ion-button class="action-button redo-button" *ngIf="endClick" (click)="cleanRecording()">🔄 Redo</ion-button>
      <ion-button class="action-button play-button"
        *ngIf="endClick"
        [ngClass]="{'pulse': isPlaying, 'red-button': isPlaying}"
        (click)="playRecording()">
        {{ isPlaying ? '🔊 Playing' : '🎶 Play' }}
      </ion-button>
    </ion-row>
    <ion-row class="button-row">
      <ion-button class="action-button save-button" *ngIf="endClick" (click)="saveRecording()">Inference</ion-button>
    </ion-row>
  </ion-grid>

</ion-content>
